import { Box, Typography } from "@mui/material";
import ScheduleIcon from "@mui/icons-material/Schedule";
import { useEffect, useState } from "react";

export const MAINTENANCE_BANNER_HEIGHT = 28;

/** Hide the notice at Sunday 13 Sep 2026, 3:00 PM IST (maintenance start). */
export const MAINTENANCE_HIDE_AT = new Date("2026-09-13T15:00:00+05:30");

export function isMaintenanceBannerVisible(): boolean {
  return Date.now() < MAINTENANCE_HIDE_AT.getTime();
}

export function useMaintenanceBannerVisible(): boolean {
  const [visible, setVisible] = useState(isMaintenanceBannerVisible);

  useEffect(() => {
    if (!isMaintenanceBannerVisible()) {
      setVisible(false);
      return;
    }

    setVisible(true);
    const delay = Math.max(0, MAINTENANCE_HIDE_AT.getTime() - Date.now());
    const timer = window.setTimeout(() => setVisible(false), delay);
    return () => window.clearTimeout(timer);
  }, []);

  return visible;
}

export default function MaintenanceBanner() {
  const visible = useMaintenanceBannerVisible();

  if (!visible) {
    return null;
  }

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 14000,
        height: `${MAINTENANCE_BANNER_HEIGHT}px`,
        backgroundColor: "#fae588",
        color: "#5d4e00",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 0.75,
        px: 1,
        boxSizing: "border-box",
      }}
    >
      <ScheduleIcon sx={{ fontSize: "16px", flexShrink: 0 }} />
      <Typography
        component="span"
        sx={{
          fontSize: "12px !important",
          fontWeight: 600,
          color: "#5d4e00 !important",
          lineHeight: 1.2,
          textAlign: "center",
        }}
      >
        Scheduled Maintenance: Sunday, 13 September 2026, 3:00 PM to 4:00 PM,
        the service will be unavailable.
      </Typography>
    </Box>
  );
}
